'use strict';

export { default } from './imageCell.container';
